<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="copyright-information">
<p>By the Same Author</p><br/>
<p><em>My Dog, Moss</em></p>
<p><em>Surprise at the Beach</em></p>
<p><em>The Bronson Escapades</em></p>
<p><em>The Wolf Cub</em></p>
<p><em>Whisper (Book One)</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?2b843e5a